<template>
    <div class="empty-state-container">
        <div class="empty-state-image">
            <img
                src="@/assets/images/empty-state.svg"
                alt="No data"
            >
        </div>
    </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'EmptyStateIcon' });
</script>

<style scoped>
.empty-state-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
}

.empty-state-image {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 600px;
    width: 100%;
}

.empty-state-image img {
    width: 100%;
    max-width: 600px;
    height: auto;
    display: block;
}
</style>
